import axios from 'axios'

type ContactUsRequestType = {}

export function send(body: ContactUsRequestType, locale: string) {
  return axios.post(`/contact-us/request?_locale=${locale}`, body)
}
